import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="map-footer">
            <div className="footer-container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <h3>MAPDESIGN</h3>
                        <p>creative studio</p>
                    </div>

                    <div className="footer-links">
                        <div className="footer-col">
                            <h4>Serviços</h4>
                            <ul>
                                <li>Branding & Rebranding</li>
                                <li>Web Design & UI/UX</li>
                                <li>Identidade Visual</li>
                                <li>Design Editorial</li>
                            </ul>
                        </div>

                        <div className="footer-col">
                            <h4>Contacto</h4>
                            <ul>
                                <li>Email: contato@mapdesign.pt</li>
                                <li>Portugal</li>
                            </ul>
                        </div>

                        <div className="footer-col">
                            <h4>Redes Sociais</h4>
                            <div className="social-links">
                                <a href="https://www.behance.net/newwdc" target="_blank" rel="noopener noreferrer">
                                    Behance
                                </a>
                                <a href="#" target="_blank" rel="noopener noreferrer">
                                    Instagram
                                </a>
                                <a href="#" target="_blank" rel="noopener noreferrer">
                                    LinkedIn
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} MAPDESIGN. creative studio.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
